// Array that holds all the stock actions
export const stockActionsPursue  = [
  "attacked",
  "expressed disapproval",
  "complained",
  "made threats",
  "expressed frustration",
  "criticized"
];

export const stockActionsWithdraw = [
  "zoned out",
  "became quiet",
  "analyzed",
  "walked away",
  "expressed frustration",
  "placated",
  "sulked",
  "tried to reason"
]